var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolSearchIcSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.118 2.76393C30.4142 2.41202 29.5858 2.41202 28.882 2.76393L8.88197 12.7639C8.035 13.1874 7.5 14.0531 7.5 15V30C7.5 36.6555 9.65135 42.2282 13.5073 46.7902C17.3231 51.3045 22.7118 54.7195 29.0535 57.3137C29.66 57.562 30.34 57.562 30.9465 57.3137C37.2882 54.7195 42.6768 51.3045 46.4927 46.7902C50.3487 42.2282 52.5 36.6555 52.5 30V15C52.5 14.0531 51.965 13.1874 51.118 12.7639L31.118 2.76393ZM12.5 30V16.5451L30 7.79508L47.5 16.5451V30C47.5 35.4813 45.7625 39.9087 42.674 43.5625C39.7152 47.063 35.4303 49.9507 30 52.289C24.5697 49.9507 20.2848 47.063 17.326 43.5625C14.2375 39.9087 12.5 35.4813 12.5 30ZM41.893 24.1331C42.7948 23.0877 42.6785 21.509 41.633 20.6071C40.5877 19.7052 39.009 19.8215 38.107 20.8669L26.9067 33.849L21.7506 28.792C20.7648 27.8253 19.182 27.8405 18.2152 28.8263C17.2484 29.812 17.2637 31.3948 18.2494 32.3615L25.3082 39.2847C25.8015 39.7685 26.4727 40.0265 27.1628 39.9977C27.853 39.969 28.5005 39.656 28.9517 39.133L41.893 24.1331Z",
    fill: "#FFB629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolSearchIcSecure);
export default __webpack_public_path__ + "static/media/sol-search-ic-secure.2fcf469e3b5988f84d46299f3e58644f.svg";
export { ForwardRef as ReactComponent };